import * as React from 'react'

const LocationPin = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    aria-label='Location Pin'
    fill='none'
    height='20'
    role='img'
    strokeLinecap='round'
    strokeLinejoin='round'
    strokeWidth='2'
    stroke='currentColor'
    viewBox='0 0 24 24'
    width='20'
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>Location Pin</title>
    <circle cx='12' cy='12' r='10' />
    <line x1='12' y1='2' x2='12' y2='6' />
    <line x1='12' y1='18' x2='12' y2='22' />
    <line x1='2' y1='12' x2='6' y2='12' />
    <line x1='18' y1='12' x2='22' y2='12' />
    <circle cx='12' cy='12' r='1' />
  </svg>
)

export default LocationPin



// WEBPACK FOOTER //
// ./src/components/icons/ui/LocationPin.tsx